import '../../../../public/static/plugins/bootstrap-input/js/fileinput.js';
import '../../../../public/static/plugins/bootstrap-input/css/fileinput.min.css';

class ImageInputManager {
    constructor() {
        this.footer = footerTemplate;
    }

    init() {
        this.inputFile = $('input[type=file]');
        this.renderExistedImages();
        this.prepareFileData();
        this.onFileLoadAction();
    }

    renderExistedImages() {
        let self = this;
        self.inputFile.each(function (index) {
            let overwriteInitial = ($(this).attr('multiple') !== 'multiple');
            let domainId = $(this).parents('.domain-panel').data('domain');
            let entityId = $(this).data('entity-id');
            let entity = $(this).data('entity');
            let type = $(this).data('type') ? $(this).data('type') : 'common';

            let previewFullObject = self.getPreviewFullObjectByType(type, domainId, entityId, entity);

            $(this).fileinput({
                language: 'en',
                allowedFileTypes: ["image"],
                showUpload: false,
                overwriteInitial: overwriteInitial,
                initialPreviewConfig: previewFullObject.initialPreviewConfig,
                previewThumbTags: previewFullObject.previewThumbTags,
                initialPreviewThumbTags: previewFullObject.initialPreviewThumbTags,
                initialPreview: previewFullObject.initialPreview,
                layoutTemplates: {footer: self.footer},
                showCaption: false,
                slugCallback: function (filename) {
                    return filename;
                }
            });
        });
    }

    getPreviewFullObjectByType(type, domainId, entityId, entity) {
        let self = this;
        let previewFullObject = {
            initialPreviewConfig: [],
            initialPreview: [],
            initialPreviewThumbTags: [],
            previewThumbTags: {
                '{alt}': '',
                '{title}': ''
            }
        };

        let filter = "[data-type=" + type + "]";
        filter = domainId ? filter + "[data-domain=" + domainId + "]" : filter;
        filter = type === 'entity' ? filter + "[data-entity-id=" + entityId + "]" : filter;
        filter = entity ? filter + "[data-entity=" + entity.replaceAll('\\', '\\\\') + "]" : filter;

        $(".existing_images").filter(filter).each(function (index) {
            previewFullObject = self.preparePreviewFullObject(previewFullObject, index, $(this));
        });

        return previewFullObject;
    }

    preparePreviewFullObject(previewFullObject, index, el) {
        previewFullObject.initialPreviewConfig[index] = this.prepareImagePreviewObject(el);
        previewFullObject.initialPreview[index] = this.prepareImageTag(el);
        previewFullObject.initialPreviewThumbTags[index] = this.preparePreviewThumbTags(el);

        return previewFullObject;
    }

    /**
     * Метод подготавливает тег для превью
     * @param el
     * @returns {string}
     */
    prepareImageTag(el) {
        return '<img src="' + $(el).data('preview') + '"' +
            ' class="file-preview-image"' +
            ' alt="' + $(el).data('alt') + '"' +
            ' title="' + $(el).data('title') + '"' +
            ' data-type="' + $(el).data('type') + '"' +
            ' data-name="' + $(el).data('name') + '"' + '>';
    }

    /**
     * Метод подготавливает объект превью
     * @param el
     * @returns {Object}
     */
    prepareImagePreviewObject(el) {
        return {
            src: this.prepareImageTag(el),
            key: $(el).data('id'),
            caption: $(el).data('name'),
            url: '/images/remove'
        };
    }

    preparePreviewThumbTags(el) {
        return {
            '{alt}': $(el).data('alt'),
            '{title}': $(el).data('title')
        }
    }

    prepareFileData() {
        $("input[name*='fileData']").remove();
        $.each($('img.file-preview-image'), function (index, img) {
            let domainId = ($(this).parents('.domain-panel').data('domain'));
            let domain = (domainId) ? domainId : 0;
            let alt = $(this).next('.file-thumbnail-footer').find('.alt').val();
            let title = $(this).next('.file-thumbnail-footer').find('.title').val();
            let type = $(this).data('type') ? $(this).data('type') : 'common';
            let name = $(this).closest('.file-input').find('input[type="file"]').data('file');
            let entity = $(this).closest('.file-input').find('input[type="file"]').data('entity');
            let fileDataKey = 'fileData[' + type + '][' + domain + '][]';
            $('input[type=file]').parents('form').append(
                $('<input/>')
                    .attr('type', 'hidden')
                    .attr('name', fileDataKey)
                    .val(
                        'name=' + $(this).data('name') +
                        '&title=' + title +
                        '&sorting=' + (index + 1) +
                        '&alt=' + alt +
                        '&domain_id=' + domain
                    )
            );
        });
    }

    onFileLoadAction() {
        let self = this;
        this.inputFile.on('fileloaded', function (event, file, previewId, index, reader) {
            $("#" + previewId).find('img').attr('data-type', $(this).data('type'));
            self.prepareFileData();
        });
    }
}

const footerTemplate =
    '<div class="file-thumbnail-footer">\n' +
    '   <div style="margin:5px 0;border: 1px solid #ccc;padding: 5px">\n' +
    '       <label style="margin-left:5px;font-size: 10px; font-weight: 400"> {caption} </label> <br />' +
    '       <input type="hidden" class="alt" value="{alt}">' +
    '       <input type="hidden" class="title" value="{title}">' +
    '   </div>\n' +
    '   {actions}\n' +
    '</div>';

export default ImageInputManager;
